import type { CardBullet, QuestionnaireOption } from './shared';

// ─── Bullets shared across multiple drugs ─────────────────────────────────────

export const PHARMACY_ELIGIBILITY_BULLET: CardBullet = {
    key: 'pharmacyCoverage',
    icon: 'check',
    color: 'success',
    text: 'Your pharmacy will check your coverage for eligibility.',
};

export const PHARMACY_COVERAGE_PRICING_BULLET: CardBullet = {
    key: 'pharmacyCoverage',
    icon: 'check',
    color: 'success',
    text: 'Coverage checked by your pharmacy — pricing confirmed based on your specific plan.',
};

export const INSURANCE_PRIOR_AUTH_BULLET_PROVIDER: CardBullet = {
    key: 'priorAuth',
    icon: 'warning',
    color: 'warning',
    text: '<b>May require prior authorization</b><br />Most plans require insurance approval. Work with your healthcare provider to ensure a prior authorization is submitted.',
};

export const INSURANCE_PRIOR_AUTH_BULLET_SHIPPING: CardBullet = {
    key: 'priorAuth',
    icon: 'warning',
    color: 'warning',
    text: '<b>May require prior authorization</b><br />Most plans require insurance approval - may add 5-10 business days before shipment.',
};

export const NO_INSURANCE_BULLET: CardBullet = {
    key: 'noInsurance',
    icon: 'warning',
    color: 'warning',
    text: 'Insurance is not used for this option.',
};

export const NO_PRIOR_AUTH_BULLET: CardBullet = {
    key: 'noPriorAuth',
    icon: 'check',
    color: 'success',
    text: '<b>Does not require prior authorization</b><br />No insurance approval needed.',
};

export const READY_FAST_BULLET: CardBullet = {
    key: 'readyFast',
    icon: 'check',
    color: 'success',
    text: 'Ready for checkout as soon as your prescription is verified.',
};

// ─── Strings shared across multiple drugs ─────────────────────────────────────

export const INSURANCE_SELECTIONS_HEADING =
    'Based on your insurance selections, you may have options.';

// ─── Questionnaire options shared across multiple drugs ───────────────────────

export const STANDARD_COMMERCIAL_QUESTIONNAIRE_OPTION: QuestionnaireOption = {
    id: 'commercial',
    content: {
        heading: 'I have commercial or employer insurance',
        description:
            'Through my employer, a private plan, or purchased on the health insurance exchange (ACA plans)',
    },
    target: { pathway: 'insurance', destination: 'path-select' },
};
